// Plain-function port of the Archie-UI TextArea styles (cva dropped — the
// dashboard doesn't depend on class-variance-authority; shim keeps zero new deps).
type Status = 'default' | 'error' | 'success';
type Size = 'medium' | 'small' | 'tiny';
type Resize = 'none' | 'vertical' | 'horizontal' | 'both';

const BASE =
  'w-full bg-[var(--color-white)] border border-solid rounded-[var(--archie-radius-lg)] font-normal transition-colors duration-[var(--archie-anim-duration)] box-border focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-blue-200)] focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50 min-h-[80px]';

const STATUS: Record<Status, string> = {
  default:
    'border-[var(--color-gray-200)] text-[var(--color-gray-600)] placeholder:text-[var(--color-gray-600)] hover:border-[var(--color-gray-500)] focus:border-[var(--color-blue-1000)] focus:text-[var(--color-blue-1000)]',
  error:
    'border-[var(--color-red-1000)] text-[var(--color-red-1000)] placeholder:text-[var(--color-red-1000)] focus:border-[var(--color-red-1000)]',
  success:
    'border-[var(--color-green-1000)] text-[var(--color-green-1000)] placeholder:text-[var(--color-green-1000)] focus:border-[var(--color-green-1000)]',
};

const SIZE: Record<Size, string> = {
  medium: 'px-4 py-4 text-[1rem] leading-[1.5rem]',
  small: 'px-3 py-2 text-[0.875rem] leading-[1.25rem]',
  tiny: 'p-2 text-[0.75rem] leading-[1rem]',
};

const RESIZE: Record<Resize, string> = {
  none: 'resize-none',
  vertical: 'resize-y',
  horizontal: 'resize-x',
  both: 'resize',
};

export function textAreaStyles(opts: { status?: Status | null; size?: Size | null; resize?: Resize | null } = {}): string {
  return [BASE, STATUS[opts.status ?? 'default'], SIZE[opts.size ?? 'medium'], RESIZE[opts.resize ?? 'vertical']].join(' ');
}

export function textAreaContainerStyles(_opts: { size?: Size | null } = {}): string {
  return 'relative w-full';
}
